import React from 'react';
import { Card, CardContent, Stack, Typography, Box, alpha } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';

const StatsCards = ({ stats }) => {
  const mdUp = useResponsive('up', 'md');

  return (
    <Box display={mdUp ? 'flex' : ''} gap={2} marginY={3}>
      {stats?.map((stat, index) => (
        <Card
          key={index}
          sx={{
            minWidth: 200,
            flex: 1,
            marginBottom: mdUp ? 0 : 2,
            transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: (theme) => theme.customShadows?.z12 || theme.shadows[12],
            },
            border: (theme) => `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
          }}
        >
          <CardContent sx={{ py: 3 }}>
            <Stack direction="row" spacing={2} alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 48,
                  height: 48,
                  borderRadius: '12px',
                  backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                  color: 'primary.main',
                }}
              >
                {React.cloneElement(stat.icon, { sx: { fontSize: 24 } })}
              </Box>
              <Box>
                <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 600, mb: 0.5 }}>
                  {stat.title}
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                  {stat.value}
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default StatsCards;
